var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsaSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: 0.499969,
    width: 9,
    height: 7.5,
    fill: "#253B80"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1.5,
    transform: "matrix(-1 0 0 1 14.75 6.49997)",
    fill: "#FF4B3D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1.5,
    transform: "matrix(-1 0 0 1 14.75 3.50003)",
    fill: "#FF4B3D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 1.5,
    transform: "matrix(-1 0 0 1 14.75 9.5)",
    fill: "#FF4B3D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 1.5,
    transform: "matrix(-1 0 0 1 14.75 12.5)",
    fill: "#FF4B3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.625 4.08582L7.46229 4.21289L7.4602 4.00646L7.2594 3.95848L7.4195 3.82813L7.33181 3.64122L7.53354 3.68512L7.625 3.50003L7.71646 3.68512L7.91819 3.64122L7.8305 3.82813L7.9906 3.95848L7.7898 4.00646L7.78771 4.21289L7.625 4.08582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1156 4.08582L5.95289 4.21289L5.9508 4.00646L5.75 3.95848L5.9101 3.82813L5.82241 3.64122L6.02414 3.68512L6.1156 3.50003L6.20706 3.68512L6.40879 3.64122L6.3211 3.82813L6.4812 3.95848L6.2804 4.00646L6.27831 4.21289L6.1156 4.08582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6156 4.08582L4.45289 4.21289L4.4508 4.00646L4.25 3.95848L4.4101 3.82813L4.32241 3.64122L4.52414 3.68512L4.6156 3.50003L4.70706 3.68512L4.90879 3.64122L4.8211 3.82813L4.9812 3.95848L4.7804 4.00646L4.77831 4.21289L4.6156 4.08582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1156 4.08582L2.95289 4.21289L2.9508 4.00646L2.75 3.95848L2.9101 3.82813L2.82241 3.64122L3.02414 3.68512L3.1156 3.50003L3.20706 3.68512L3.40879 3.64122L3.3211 3.82813L3.4812 3.95848L3.2804 4.00646L3.27831 4.21289L3.1156 4.08582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 2.58579L6.71229 2.71286L6.7102 2.50642L6.5094 2.45845L6.6695 2.32809L6.58181 2.14119L6.78354 2.18509L6.875 2L6.96646 2.18509L7.16819 2.14119L7.0805 2.32809L7.2406 2.45845L7.0398 2.50642L7.03771 2.71286L6.875 2.58579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3656 2.58579L5.20289 2.71286L5.2008 2.50642L5 2.45845L5.1601 2.32809L5.07241 2.14119L5.27414 2.18509L5.3656 2L5.45706 2.18509L5.65879 2.14119L5.5711 2.32809L5.7312 2.45845L5.5304 2.50642L5.52831 2.71286L5.3656 2.58579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6156 2.58579L4.45289 2.71286L4.4508 2.50642L4.25 2.45845L4.4101 2.32809L4.32241 2.14119L4.52414 2.18509L4.6156 2L4.70706 2.18509L4.90879 2.14119L4.8211 2.32809L4.9812 2.45845L4.7804 2.50642L4.77831 2.71286L4.6156 2.58579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1156 2.58579L2.95289 2.71286L2.9508 2.50642L2.75 2.45845L2.9101 2.32809L2.82241 2.14119L3.02414 2.18509L3.1156 2L3.20706 2.18509L3.40879 2.14119L3.3211 2.32809L3.4812 2.45845L3.2804 2.50642L3.27831 2.71286L3.1156 2.58579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 5.58573L6.71229 5.7128L6.7102 5.50636L6.5094 5.45838L6.6695 5.32803L6.58181 5.14113L6.78354 5.18502L6.875 4.99994L6.96646 5.18502L7.16819 5.14113L7.0805 5.32803L7.2406 5.45838L7.0398 5.50636L7.03771 5.7128L6.875 5.58573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3656 5.58573L5.20289 5.7128L5.2008 5.50636L5 5.45838L5.1601 5.32803L5.07241 5.14113L5.27414 5.18502L5.3656 4.99994L5.45706 5.18502L5.65879 5.14113L5.5711 5.32803L5.7312 5.45838L5.5304 5.50636L5.52831 5.7128L5.3656 5.58573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8656 5.58573L3.70289 5.7128L3.7008 5.50636L3.5 5.45838L3.6601 5.32803L3.57241 5.14113L3.77414 5.18502L3.8656 4.99994L3.95706 5.18502L4.15879 5.14113L4.0711 5.32803L4.2312 5.45838L4.0304 5.50636L4.02831 5.7128L3.8656 5.58573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3656 5.58573L2.20289 5.7128L2.2008 5.50636L2 5.45838L2.1601 5.32803L2.07241 5.14113L2.27414 5.18502L2.3656 4.99994L2.45706 5.18502L2.65879 5.14113L2.5711 5.32803L2.7312 5.45838L2.5304 5.50636L2.52831 5.7128L2.3656 5.58573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.625 7.08576L7.46229 7.21283L7.4602 7.00639L7.2594 6.95841L7.4195 6.82806L7.33181 6.64116L7.53354 6.68505L7.625 6.49997L7.71646 6.68505L7.91819 6.64116L7.8305 6.82806L7.9906 6.95841L7.7898 7.00639L7.78771 7.21283L7.625 7.08576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1156 7.08576L5.95289 7.21283L5.9508 7.00639L5.75 6.95841L5.9101 6.82806L5.82241 6.64116L6.02414 6.68505L6.1156 6.49997L6.20706 6.68505L6.40879 6.64116L6.3211 6.82806L6.4812 6.95841L6.2804 7.00639L6.27831 7.21283L6.1156 7.08576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6156 7.08576L4.45289 7.21283L4.4508 7.00639L4.25 6.95841L4.4101 6.82806L4.32241 6.64116L4.52414 6.68505L4.6156 6.49997L4.70706 6.68505L4.90879 6.64116L4.8211 6.82806L4.9812 6.95841L4.7804 7.00639L4.77831 7.21283L4.6156 7.08576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1156 7.08576L2.95289 7.21283L2.9508 7.00639L2.75 6.95841L2.9101 6.82806L2.82241 6.64116L3.02414 6.68505L3.1156 6.49997L3.20706 6.68505L3.40879 6.64116L3.3211 6.82806L3.4812 6.95841L3.2804 7.00639L3.27831 7.21283L3.1156 7.08576Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaSm);
export default __webpack_public_path__ + "static/media/USA-SM.44614717c98d68d753d8d8c193fc255a.svg";
export { ForwardRef as ReactComponent };